import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { PropostesAnulacioFilter } from '../../models/propostes-anulacio-filter';

@Component({
  selector: 'app-propostes-anulacio-filter',
  templateUrl: './propostes-anulacio-filter.component.html',
  styleUrls: ['./propostes-anulacio-filter.component.scss']
})
export class PropostesAnulacioFilterComponent implements OnInit {
  subscription: Subscription;
  filter: PropostesAnulacioFilter;
  @Output() notify: EventEmitter<PropostesAnulacioFilter> = new EventEmitter<PropostesAnulacioFilter>();


  constructor(public thisDialogRef: MatDialogRef<PropostesAnulacioFilter>, 
    @Inject(MAT_DIALOG_DATA) public data,
) {
  this.filter = data.filter;
 }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }
}
